class OmnibusRegularPrice extends HTMLElement {
  constructor() {
    super();
    this._onVariantChange = this._onVariantChange.bind(this);
    this._container = null;
  }

  connectedCallback() {
    this._container = this.closest('product-component') ?? document;
    this._container.addEventListener('theme:variant:change', this._onVariantChange);
  }

  disconnectedCallback() {
    this._container?.removeEventListener('theme:variant:change', this._onVariantChange);
    this._container = null;
  }

  _onVariantChange({ detail }) {
    const variant = detail?.variant;
    if (!variant) return;

    if (variant.compare_at_price > variant.price) {
      const discount = Math.round(
        (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
      );
      const formattedPrice = window.theme.formatMoney(
        variant.compare_at_price,
        window.theme.moneyWithCurrencyFormat
      );

      this.querySelector('.omnibus-price__label').textContent = this.dataset.label;
      this.querySelector('.omnibus-price__price').textContent = formattedPrice;
      this.querySelector('.omnibus-price__change').textContent = `(-${discount}%)`;
      this.style.visibility = '';
    } else {
      this.style.visibility = 'hidden';
    }
  }
}

if (!customElements.get('omnibus-regular-price')) {
  customElements.define('omnibus-regular-price', OmnibusRegularPrice);
}
